export const SEASON = {
  CURRENT: 2026,
  PRIOR: 2025,
};

export const TAX_YEAR = {
  CURRENT: 2025,
  PRIOR: 2024,
};
